import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CreateCassetteComponent } from './views/create-cassette/create-cassette.component'
import { SelectAreaComponent } from './views/select-area/select-area.component'
import { DashboardComponent } from './views/dashboard/dashboard.component'
import { WBSViewerComponent } from './views/wbs-viewer/wbs-viewer.component'
import { WBSItemViewerComponent } from './views/wbs-item-viewer/wbs-item-viewer.component'
import { SelectWbsItemComponent } from './views/select-wbs-item/select-wbs-item.component'
import { CreateAreaComponent } from './views/create-area/create-area.component'
import { IsIgxWbsSampleComponent } from './views/test/is-igx-wbs-sample.component'
import { SampleTestDataCreateComponent } from './views/sample-testdata-create/SampleTestDataCreateComponent'
import { SampleTestDataWorkDate } from './views/sample-testdata-workdate/SampleTestDataWorkDate'
import { UpdateWbsItemComponent } from './views/update-wbs-item/update-wbs-item.component'
import { CreateAreaUserComponent } from './views/create-area-user/create-area-user.component'
import { CreateAreaOwnerComponent } from './views/create-area-owner/create-area-owner.component'
import { SelectAreaForAreauserComponent } from './views/select-area-for-areauser/select-area-for-areauser.component'
import { SampleTestDataSelectComponent } from './views/sample-testdata-select/SampleTestDataCreateComponent'
import { TopComponent } from './views/top/top.component'

const routes: Routes = [
    {
        path: 'top',
        title: 'Top',
        component: TopComponent,
    },
    {
        path: 'select-area',
        title: 'ドキュメント管理',
        component: SelectAreaComponent,
        // loadComponent: () => import('./views/select-area/select-area.component').then((m) => m.SelectAreaComponent),
    },
    {
        path: 'settings/create-area',
        title: 'エリア作成',
        component: CreateAreaComponent,
        // loadComponent: () => import('./views/create-area/create-area.component').then((m) => m.CreateAreaComponent),
    },
    {
        path: 'settings/select-area-for-areauser',
        title: 'エリアユーザー管理',
        component: SelectAreaForAreauserComponent,
        // loadComponent: () =>
        //     import('./views/select-area-for-areauser/select-area-for-areauser.component').then(
        //         (m) => m.SelectAreaForAreauserComponent
        //     ),
    },
    {
        path: 'create-area-owner/:areaId',
        component: CreateAreaOwnerComponent,
        // loadComponent: () =>
        //     import('./views/create-area-owner/create-area-owner.component').then((m) => m.CreateAreaOwnerComponent),
    },
    {
        path: 'create-area-user/:areaId',
        component: CreateAreaUserComponent,
        // loadComponent: () =>
        //     import('./views/create-area-user/create-area-user.component').then((m) => m.CreateAreaUserComponent),
    },
    {
        path: 'create-cassette',
        component: CreateCassetteComponent,
        // data: { title: 'カセット作成'},
        // loadComponent: () =>
        //     import('./views/create-cassette/create-cassette.component').then((m) => m.CreateCassetteComponent),
    },
    {
        path: 'wbs-viewer/:areaId/:updatable',
        component: WBSViewerComponent,
        // loadComponent: () => import('./views/wbs-viewer/wbs-viewer.component').then((m) => m.WBSViewerComponent),
    },
    {
        path: 'select-wbs-item/:areaId',
        component: SelectWbsItemComponent,
        // loadComponent: () =>
        //     import('./views/select-wbs-item/select-wbs-item.component').then((m) => m.SelectWbsItemComponent),
    },
    {
        path: 'wbs-item-viewer/:areaId/:wbsItemId/:updatable',
        component: WBSItemViewerComponent,
        // loadComponent: () =>
        //     import('./views/wbs-item-viewer/wbs-item-viewer.component').then((m) => m.WBSItemViewerComponent),
    },
    {
        path: 'update-wbs-item/:areaId/:wbsItemId',
        component: UpdateWbsItemComponent,
        // loadComponent: () =>
        //     import('./views/update-wbs-item/update-wbs-item.component').then((m) => m.UpdateWbsItemComponent),
    },
    //後で消す
    {
        path: 'dashboard',
        title: 'iframe版ペタボ連携確認用',
        component: DashboardComponent,
        // loadComponent: () => import('./views/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    },
    //後で消す
    {
        path: 'mapping-sample',
        title: '物流支援サンプル',
        component: IsIgxWbsSampleComponent,
        // loadComponent: () => import('./views/test/is-igx-wbs-sample.component').then((m) => m.IsIgxWbsSampleComponent),
    },
    {
        path: 'テストデータ作成',
        title: 'テストデータ作成',
        component: SampleTestDataCreateComponent,
        // loadComponent: () =>
        //     import('./views/sample-testdata-create/SampleTestDataCreateComponent').then(
        //         (m) => m.SampleTestDataCreateComponent
        //     ),
    },
    {
        path: 'テストデータ選択',
        title: 'テストデータ選択',
        component: SampleTestDataSelectComponent,
        // loadComponent: () =>
        //     import('./views/sample-testdata-select/SampleTestDataCreateComponent').then(
        //         (m) => m.SampleTestDataSelectComponent
        //     ),
    },
    {
        path: '納品日指定',
        title: '納品日指定',
        component: SampleTestDataWorkDate,
        // loadComponent: () =>
        //     import('./views/sample-testdata-workdate/SampleTestDataWorkDate').then((m) => m.SampleTestDataWorkDate),
    },
    { path: '', redirectTo: 'top', pathMatch: 'full' },
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
